/* eslint-disable */

import React from "react";
import { useState } from "react";
import ModelComponentTicket from "../../../ui-components/model-component-ticket/model-component-ticket";

const TeamBoardTicket = ({
  title,
  status,
  assignee,
  priority,
  dueDate,
  onDragEnd,
  onDragStart,
}) => {
  return (
    <div
      draggable={true}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      className={`w-[200px] h-[100px] rounded-lg
      bg-color-background-tertiary dark:bg-color-dark-background-tertiary
      `}
    >
      <div>{title}</div>
    </div>
  );
};

const TeamBoardColumn = ({
  status,
  tickets,
  draggingTicket,
  setDraggingTicket,
  onDropTicket,
}) => {
  const title = {
    BACKLOG: "Backlog",
    NEXT_SPRINT: "Next Sprint",
    THIS_SPRINT: "This Sprint",
    DOING: "Doing",
    DONE_TODAY: "Done Today",
    DONE: "Done",
  }[status];

  let opacity = "opacity-100";
  let hover = "";

  if (draggingTicket) {
    hover = "hover:opacity-50";
  }

  const filteredTickets = tickets.filter((t) => t.status === status);

  return (
    <div
      className={`flex flex-col gap-4 h-full  p-2 rounded-lg items-center
       ${opacity} transition-all ${hover} min-w-[220px]
       bg-color-background-tertiary dark:bg-color-dark-background-tertiary
       
    `}
      onMouseUp={onDropTicket}
      onDrop={onDropTicket}
    >
      <div
        className={`text-xs font-bold 
        dark:text-color-dark-text-tertiary text-color-text-tertiary
        `}
      >
        {title}
      </div>
      {filteredTickets.map((ticket) => (
        // <TeamBoardTicket
        //   title={ticket.title}
        //   status={ticket.status}
        //   assignee={ticket.assignee}
        //   priority={ticket.priority}
        //   dueDate={ticket.dueDate}
        //   onDragStart={() => setDraggingTicket(ticket)}
        // />
        <ModelComponentTicket id={ticket.id} />
      ))}
    </div>
  );
};

const TeamBoard = () => {
  const [tickets, setTickets] = useState([
    {
      id: "ticket__F214D4BF-762A-4BDC-A655-1B4314F444E0",
      title: "Ticket 1",
      status: "BACKLOG",
      assignee: "John Doe",
      priority: "High",
      dueDate: "2022-12-31",
    },
    {
      id: "ticket__F214D4BF-762A-4BDC-A655-1B4314F444E1",
      title: "Ticket 2",
      status: "BACKLOG",
      assignee: "John Doe",
      priority: "High",
      dueDate: "2022-12-31",
    },
  ]);

  const [draggingTicket, setDraggingTicket] = useState(null);

  const onDropTicket = (columnId) => {
    console.log(columnId, draggingTicket);
    if (!draggingTicket) {
      return;
    }
    const newTickets = [...tickets];
    newTickets.find((t) => t.id == draggingTicket.id).status = columnId;
    setTickets(newTickets);
    setDraggingTicket(null);
  };

  return (
    <div
      className={`flex flex-row h-full w-full gap-4
     overflow-x-auto overflow-y-hidden 
    `}
    >
      <TeamBoardColumn
        status={"BACKLOG"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
        onDropTicket={() => onDropTicket("Open")}
      />
      <TeamBoardColumn
        status={"NEXT_SPRINT"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
        onDropTicket={() => onDropTicket("Closed")}
      />
      <TeamBoardColumn
        status={"THIS_SPRINT"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
      />
      <TeamBoardColumn
        status={"DOING"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
      />
      <TeamBoardColumn
        status={"DONE_TODAY"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
      />
      <TeamBoardColumn
        status={"DONE"}
        tickets={tickets}
        draggingTicket={draggingTicket}
        setDraggingTicket={setDraggingTicket}
      />
    </div>
  );
};

const NimbusTeamsInstance = () => {
  return (
    <div className="flex flex-col  gap-4 h-full w-full overflow-scroll">
      <div
        className={`flex flex-col gap-2 text-left p-4 rounded-lg max-w-md
      bg-color-background-secondary dark:bg-color-dark-background-secondary
      `}
      >
        <div className={`flex flex-row gap-2 items-center`}>
          <i className="fas fa-users text-2xl text-color-dark-text-primary"></i>
          <div className="font-bold text-lg whitespace-nowrap">Legal Team</div>
          <div className="flex flex-row-reverse w-full">
            <i className="flex flex-col  justify-center fas fa-user text-sm dark:text-color-dark-text-minor dark:bg-color-dark-background-tertiary w-8 h-8 text-center rounded-full border border-color-border-primary"></i>
            <i className="flex flex-col  justify-center fas fa-user text-sm dark:text-color-dark-text-minor dark:bg-color-dark-background-tertiary w-8 h-8 text-center rounded-full translate-x-4 border border-color-border-primary"></i>
            <i className="flex flex-col  justify-center fas fa-user text-sm dark:text-color-dark-text-minor dark:bg-color-dark-background-tertiary w-8 h-8 text-center rounded-full translate-x-8 border border-color-border-primary"></i>
          </div>
        </div>

        <div>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua.
        </div>
      </div>
      <TeamBoard />
    </div>
  );
};

export default NimbusTeamsInstance;
